module.exports = __webpack_public_path__ + "static/media/artunity-upload-userflow.24a1ce5d.jpg";